
function resetData(data, operation, prevData = {}) {
  const { operationType, changeField, fieldsToReset } = operation
  let result = data

  if (operationType === 'header.reset') {

    if (data[changeField] === prevData[changeField]) return data

    for (const fieldObj of fieldsToReset) {
      result[fieldObj.field] = fieldObj.value 
    }


}

  if (result) return result
  //ALWAYS RETURN AT THE END OF ALL IF STATEMENTS
  return data;
}

export default resetData